import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from '@app/helpers/authProvider';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { QRCodeLabelData } from "../components/QRCodeLabelForStorage";
import { ENV} from "@app/constants/env";
const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV.BASE_API_URL +ENV.JOB_APIURL,//need to change to ENV.JOB_APIURL when available from job service 
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  incomingArgs,
  api,
  extraOptions
) => {
  let args: string | FetchArgs = incomingArgs;
  if (typeof args === 'string') {
    args = { url: args };
  }
  try {
    const token = await getToken();
    if (token) {
      (args as FetchArgs).headers = {
        ...(args as FetchArgs).headers,
        Authorization: `Bearer ${token}`,
      };
    }
    return await rawBaseQuery(args, api, extraOptions);
  } catch {
    return { error: { status: 500, data: 'Token retrieval failed' } } as any;
  }
};

export const qrcodeLabelApi = createApi({
  reducerPath: 'qrcodeLabelApi',
  baseQuery: authBaseQuery,
  tagTypes: ['QRCodeLabel'],
  endpoints: (builder) => ({
    getPrintLabel: builder.query<QRCodeLabelData[], string>({
      query: (labelIds) => ({
        url: `QrcodeLabel/GetPrintLabel/${labelIds}`,
        method: 'GET',
      }),
      transformResponse: (response: any) => Array.isArray(response) ? response : [],
      providesTags: ['QRCodeLabel'],
    }),
    getPrintShippingLabel: builder.query<QRCodeLabelData[], string>({
      query: (labelIds) => ({
        url: `QrcodeLabel/GetPrintShippingLabel/${labelIds}`,
        method: 'GET',
      }),
      transformResponse: (response: any) => Array.isArray(response) ? response : [],
      providesTags: ['QRCodeLabel'],
    }),
      getQrDataByHeaderId: builder.mutation<QRCodeLabelData[], { lineItemId: string }>({
        query: ({ lineItemId }) => ({
          url: `Qrcode/GetQrDataByHeaderId/${lineItemId}`,
          method: 'POST',
          headers: { 'accept': '*/*' },
          body: '',
        }),
        transformResponse: (response: any) => Array.isArray(response) ? response : [response],
      }),

      getQrDataByDetailId: builder.mutation<QRCodeLabelData[], { detailId: string; userId?: string }>(
        {
          query: ({ detailId, userId = localStorage.getItem('userid') ? localStorage.getItem('userid')! : '0' }) => ({
            url: `Qrcode/GetQRCodelabelsDetailsID/${detailId}?UserId=${userId}`,
            method: 'POST',
            headers: { 'accept': '*/*' },
            body: '',
          }),
          transformResponse: (response: any) => Array.isArray(response) ? response : [response],
        }
      ),
    getPrintNPLabel: builder.query<QRCodeLabelData[], string>({
      query: (labelIds) => ({
        url: `QrcodeLabel/GetPrintNPLabel/${labelIds}`,
        method: 'GET',
      }),
      transformResponse: (response: any) => Array.isArray(response) ? response : [],
      providesTags: ['QRCodeLabel'],
    }),
    sendMailPrintHeader: builder.mutation<any, { pdfData: string; formtitle: string; mailid: string; LabeleId: string }>({
      query: (body) => ({
        url: `Qrcode/api/SendMailPrintHeader`,
        method: 'POST',
        headers: { 
          'accept': '*/*',
          'Content-Type': 'application/json',
        },
        body,
      }),
    }),
sendMailPrintDetail: builder.mutation<any, { pdfData: string; formtitle: string; mailid: string; LabeleId: string }>({
      query: (body) => ({
        url: `Qrcode/api/SendMailPrintDetails`,
        method: 'POST',
        headers: { 
          'accept': '*/*',
          'Content-Type': 'application/json',
        },
        body,
      }),
    }),
    // Add UpdatePrint mutation
    updatePrint: builder.mutation<any, { labeleIds: string; userId: string }>({
      query: ({ labeleIds, userId }) => ({
        url: `Qrcode/UpdatePrint/${labeleIds}/${userId}`,
        method: 'POST',
        headers: { 'accept': '*/*' },
        body: '',
      }),
    }),
    
    // Add PrintSaveAddress mutation
    printSaveAddress: builder.mutation<any, { lineItemId: string | number; userId: string | number }>({
      query: ({ lineItemId, userId }) => ({
        url: `Qrcode/api/PrintSaveAddress/${lineItemId}/${userId}`,
        method: 'POST',
        headers: { 'accept': '*/*' },
        body: '',
      }),
    }),
     printSubLabel: builder.mutation<any, { labeleId: string | number; addressId: string | number }>({
      query: ({ labeleId, addressId }) => ({
        url: `Qrcode/api/PrintSubLabel/${labeleId}/${addressId}`,
        method: 'POST',
        headers: { 'accept': '*/*' },
        body: '',
      }),
    }),
  }),
});

export const { useGetPrintLabelQuery, useGetPrintNPLabelQuery, useGetPrintShippingLabelQuery, useGetQrDataByHeaderIdMutation, useGetQrDataByDetailIdMutation, useSendMailPrintHeaderMutation, useSendMailPrintDetailMutation, useUpdatePrintMutation, usePrintSaveAddressMutation,usePrintSubLabelMutation, } = qrcodeLabelApi;
